import React from "react";
import { Divider, Radio, Checkbox, Button, Slider, Select, Input } from "antd";
import "./Interactome.scss";
import "../../scss/components/buttons.scss";
import "../../scss/style.scss";
import { InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import hosts from "../Hosts/animals.json";
import { env } from "../../env";
import { pathogen } from "../Hosts/pathogen";
import { orgDb } from "./orgDb";
import { Modal, Form } from "react-bootstrap";
import FileInput from "../../components/FileInput/FileInput";
import test from "./test.gif";

const urlParams = new URLSearchParams(window.location.search);

const mhost = urlParams.get("host");
const mpath = urlParams.get("pathogen");

const CheckboxGroup = Checkbox.Group;
const interologOptions = ["HPIDB", "MINT", "BioGRID", "IntAct", "VirHostNet"];

const domainOptions = ["3DID", "IDDI", "DOMINE"];

const interologCheckedList = ["HPIDB"];
const domainCheckedList = ["3DID"];

export default class Interactome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      interactomeType: "interactome",
      searchType: 'protein',
      annotType: 'go',
      idType: 'host',
      ostype: "unique",
      selectedMethods: ['interolog'],
      checkedList: interologCheckedList,
      dcheckedList: domainCheckedList,
      checkAll: false,
      dcheckAll: false,
      type: "single",
      species: mhost,
      keyword: '',
      pathogen: mpath,
      interologIdentity: 80,
      phyloIdentity: 80,
      interologCoverage: 80,
      phyloCoverage: 80,
      interologEvalue: 1e-20,
      phyloEvalue: 1e-20,
      interologPidentity: 80,
      phyloPidentity: 80,
      interologPcoverage: 80,
      phyloPcoverage: 80,
      interologPevalue: 1e-20,
      phyloPevalue: 1e-20,
      pidentity: 80,
      pcoverage: 80,
      pevalue: 1e-20,
      resultid: "",
      isOpen: false,
      ppiOpen: false,
      domainOpen: false,
      goOpen: false,
      phyloOpen: false,
      consensusOpen: false,
      concatenationOpen: false,
      fileOpen: false,
      genomePool: "UP82",
      phylothreshold: 0.98,
      genes: '',
      hgenes: "",
      pgenes: "",
      gomeasure: "Wang",
      goorgdb: 'org.Hs.eg.db',
      gominsimilarity: 0.5,
      geneHintOn: false,
      isMultiple: false,
      sampleHostProteins: [], 
      samplePathogenProteins: [], 
      sampleProteinsLoading: true, 
      sampleProteinsError: null, 
    };
    this.radioHandler = this.radioHandler.bind(this);
    this.checkboxHandler = this.checkboxHandler.bind(this);
    this.speciesHandler = this.speciesHandler.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCheckAllChange = this.onCheckAllChange.bind(this);
    this.onChange2 = this.onChange2.bind(this);
    this.onCheckAllChange2 = this.onCheckAllChange2.bind(this);
    this.interologIdentityHandler = this.interologIdentityHandler.bind(this);
    this.phyloIdentityHandler = this.phyloIdentityHandler.bind(this);
    this.interologCoverageHandler = this.interologCoverageHandler.bind(this);
    this.phyloCoverageHandler = this.phyloCoverageHandler.bind(this);
    this.interologEvalueHandler = this.interologEvalueHandler.bind(this);
    this.phyloEvalueHandler = this.phyloEvalueHandler.bind(this);
    this.interologPidentityHandler = this.interologPidentityHandler.bind(this);
    this.phyloPidentityHandler = this.phyloPidentityHandler.bind(this);
    this.interologPcoverageHandler = this.interologPcoverageHandler.bind(this);
    this.phyloPcoverageHandler = this.phyloPcoverageHandler.bind(this);
    this.interologPevalueHandler = this.interologPevalueHandler.bind(this);
    this.phyloPevalueHandler = this.phyloPevalueHandler.bind(this);
    this.interactomeHandler = this.interactomeHandler.bind(this);
    this.intHandler = this.intHandler.bind(this);
    this.fileSelected = this.fileSelected.bind(this);
    this.getInteractions = this.getInteractions.bind(this);
    this.setGeneHint = this.setGeneHint.bind(this);
    this.idHandler = this.idHandler.bind(this);
    this.goMeasureRadioHandler = this.goMeasureRadioHandler.bind(this);
    this.goOrgDbSelectHandler = this.goOrgDbSelectHandler.bind(this);
    this.handleHostGeneChange = this.handleHostGeneChange.bind(this);
    this.handlePathogenGeneChange = this.handlePathogenGeneChange.bind(this);
    this.getGoMinSimilarity = this.getGoMinSimilarity.bind(this);
    this.pgHandler = this.pgHandler.bind(this);
    this.phyloThresholdHandler = this.phyloThresholdHandler.bind(this);
    this.annotationHandler = this.annotationHandler.bind(this);
    this.accessionHandler = this.accessionHandler.bind(this);
    this.searchHandler = this.searchHandler.bind(this);
    this.keywordHandler = this.keywordHandler.bind(this);
    this.geneHandler = this.geneHandler.bind(this);
    this.fileHandler = this.fileHandler.bind(this);
    this.fetchSampleProteins = this.fetchSampleProteins.bind(this);
  }

  radioHandler(e) {
    const type = e.target.value;
    let isMultiple = true;
    let selectedMethods = this.state.selectedMethods;
    if (type === 'single') {
      isMultiple = false;
      if (selectedMethods.length > 0) {
        selectedMethods = selectedMethods[0];
      }
    }
    this.setState({
      type: type,
      isMultiple: isMultiple,
      selectedMethods: selectedMethods,
    });
  }

  checkboxHandler(checkedValues) {
    if (!this.state.isMultiple) {
      // If only one selection is allowed, make sure only the first selected checkbox is in the array
      this.setState({
        selectedMethods: checkedValues.length > 0 ? [checkedValues[checkedValues.length - 1]] : []
      });
    } else {
      this.setState({
        selectedMethods: checkedValues
      });
    }
  }

  goMeasureRadioHandler(e) {
    this.setState({
      gomeasure: e.target.value,
    });
  }

  goOrgDbSelectHandler(e) {
    this.setState({
      goorgdb: e,
    });
    console.log(this.state.goorgdb)
  }
  getGoMinSimilarity = (value) => {
    this.setState({ gominsimilarity: value / 100 });
  };

  speciesHandler = (e) => {
    this.setState({ species: e.target.value });
  };

  idHandler = (e) => {
    this.setState({ searchType: e.target.value });
  };
  pgHandler = (e) => {
    this.setState({ genomePool: e.target.value });
  };

  phyloThresholdHandler(e) {
    this.setState({ phylothreshold: e.target.value });
  }

  interologIdentityHandler(e) {
    this.setState({ interologIdentity: e.target.value });
  }
  phyloIdentityHandler(e) {
    this.setState({ phyloIdentity: e.target.value });
  }
  interologCoverageHandler(e) {
    this.setState({ interologCoverage: e.target.value });
  }
  phyloCoverageHandler(e) {
    this.setState({ phyloCoverage: e.target.value });
  }
  interologEvalueHandler(e) {
    this.setState({ interologEvalue: e.target.value });
  }
  phyloEvalueHandler(e) {
    this.setState({ phyloEvalue: e.target.value });
  }
  interologPidentityHandler(e) {
    this.setState({ interologPidentity: e.target.value });
  }
  phyloPidentityHandler(e) {
    this.setState({ phyloPidentity: e.target.value });
  }
  interologPcoverageHandler(e) {
    this.setState({ interologPcoverage: e.target.value });
  }
  phyloPcoverageHandler(e) {
    this.setState({ phyloPcoverage: e.target.value });
  }
  interologPevalueHandler(e) {
    this.setState({ interologPevalue: e.target.value });
  }
  phyloPevalueHandler(e) {
    this.setState({ phyloPevalue: e.target.value });
  }
  annotationHandler(e) {
    this.setState({ annotType: e.target.value })
  }
  keywordHandler(e) {
    this.setState({ keyword: e.target.value })
  };
  searchHandler = (e) => {
    this.setState({ searchType: e.target.value })
  };
  accessionHandler = (e) => {
    this.setState({ idType: e.target.value, genes: '' })
  };
  fileHandler = (fileText) => {
    const protein = fileText.trim().split("\n");
    this.setState({ genes: protein });
  };

  onChange(list) {
    this.setState({
      checkedList: list,

      checkAll: list.length === interologOptions.length,
    });
  }

  onChange2(list) {
    this.setState({
      dcheckedList: list,

      dcheckAll: list.length === domainOptions.length,
    });
  }

  onCheckAllChange(e) {
    this.setState({
      checkedList: e.target.checked ? interologOptions : [],

      checkAll: e.target.checked,
    });
  }
  onCheckAllChange2(e) {
    this.setState({
      dcheckedList: e.target.checked ? domainOptions : [],

      dcheckAll: e.target.checked,
    });
  }

  openModel = () => this.setState({ isOpen: true });
  closeModel = () => this.setState({ isOpen: false });

  ppiModalOpen = () => this.setState({ ppiOpen: true });
  ppiModalClose = () => this.setState({ ppiOpen: false });

  domainModalOpen = () => this.setState({ domainOpen: true });
  domainModalClose = () => this.setState({ domainOpen: false });

  goModalOpen = () => this.setState({ goOpen: true });
  goModalClose = () => this.setState({ goOpen: false });

  phyloModalOpen = () => this.setState({ phyloOpen: true });
  phyloModalClose = () => this.setState({ phyloOpen: false });

  consensusModalOpen = () => this.setState({ consensusOpen: true });
  consensusModalClose = () => this.setState({ consensusOpen: false });

  concatenationModalOpen = () => this.setState({ concatenationOpen: true });
  concatenationModalClose = () => this.setState({ concatenationOpen: false });

  fileModalOpen = () => this.setState({ fileOpen: true });
  fileModalClose = () => this.setState({ fileOpen: false });

  interactomeHandler(e) {
    this.setState({ interactomeType: e.target.value });
  }

  intHandler(e) {
    this.setState({ ostype: e.target.value });
  }

  fileSelected(fileText) {
    const protein = fileText.trim().split("\n");
    this.setState({ genes: protein });
  }
  geneHandler(e) {
    const input = e.target.value;

    // Split the input based on commas, new lines, and tabs
    const genesArray = input
      .split(/,|\n|\t/)
      .map((gene) => gene.trim()) // Trim each gene
      .filter((gene) => gene); // Remove empty entries

    const genesString = genesArray.join(",");

    this.setState({ genes: genesString });
  }

  handleHostGeneChange(e) {
    const input = e.target.value;

    // Split the input based on commas, new lines, and tabs
    const genesArray = input
      .split(/,|\n|\t/)
      .map((gene) => gene.trim()) // Trim each gene
      .filter((gene) => gene); // Remove empty entries

    const genesString = genesArray.join(",");
    this.setState({ hgenes: genesString });
  }

  handlePathogenGeneChange(e) {
    const input = e.target.value;

    // Split the input based on commas, new lines, and tabs
    const genesArray = input
      .split(/,|\n|\t/)
      .map((gene) => gene.trim()) // Trim each gene
      .filter((gene) => gene); // Remove empty entries

    const genesString = genesArray.join(",");

    this.setState({ pgenes: genesString });
  }

  setGeneHint(hint) {
    this.setState({ geneHintOn: hint });
  }

  fetchSampleProteins = async () => {
    this.setState({ sampleProteinsLoading: true, sampleProteinsError: null }); // Set loading state
    
    let hspecies;
    try {
      const hostData = hosts.find((item) => item.name === this.state.species);
      if (hostData) {
        hspecies = hostData.sname.replaceAll(" ", "_").replaceAll(".", "").replaceAll("(", "_").replaceAll(")", "_");
      } else {
        // Handle case where host might not be found (though unlikely based on usage)
        console.error("Host species data not found for:", this.state.species);
        this.setState({ sampleProteinsLoading: false, sampleProteinsError: "Host species data not found." });
        return;
      }
    } catch (error) {
      console.error("Error finding host data:", error);
      this.setState({ sampleProteinsLoading: false, sampleProteinsError: "Error processing host data." });
      return;
    }

    const pspecies = this.state.pathogen; // Pathogen seems to be used directly
    
    if (!hspecies || !pspecies) {
      console.log("Host or Pathogen species not set yet.");
      this.setState({ sampleProteinsLoading: false }); // Not an error, just not ready
      return;
    }

    try {
      const response = await axios.get(`${env.BACKEND}/api/sampleProteins/`, {
        params: {
          host: hspecies,
            pathogen: pspecies
        }
      });
      this.setState({
        sampleHostProteins: response.data.hostProteins || [],
        samplePathogenProteins: response.data.pathogenProteins || [],
        sampleProteinsLoading: false,
        hspecies: hspecies,
        pspecies: pspecies
      });
    } catch (error) {
      console.error("Error fetching sample proteins:", error.response || error.message);
      this.setState({
        sampleHostProteins: [],
        samplePathogenProteins: [],
        sampleProteinsLoading: false,
        sampleProteinsError: `Failed to load sample IDs (${error.response?.status || 'Network Error'})`,
        hspecies: hspecies,
        pspecies: pspecies
      });
    }
  };

  getInteractions() {
    if ((this.state.selectedMethods.includes('gosim') || this.state.selectedMethods.includes('phylo')) &&
      (this.state.hgenes.trim() === '' || this.state.pgenes.trim() === '')) {
      alert('Please, add a list of genes for both host and pathogen.')
      return;
    }

    const intdb = this.state.checkedList.map((element) => {
      return element.toLowerCase();
    });
    const intdbd = intdb.toString();
    const domdbs = this.state.dcheckedList.map((element) => {
      return element.toLowerCase();
    });
    let rids = [];
    let requests = [];
    let pspecies = this.state.pathogen;
    let hspecies = hosts
      .find((item) => item.name === this.state.species)
      .sname.replaceAll(" ", "_")
      .replaceAll(".", "")
      .replaceAll("(", "_")
      .replaceAll(")", "_");

    this.openModel();
    if (this.state.selectedMethods.includes('domain')) {
      let postBody = {
        category: 'domain',
        hspecies: hspecies,
        pspecies: pspecies,
        idType: this.state.idType,
        genes: this.state.genes,
        intdbs: intdbd,
        domdbs: domdbs,
        keyword: this.state.keyword,
        searchType: this.state.searchType,
        annotType: this.state.annotType,
        host: hspecies,
        pathogen: this.state.pathogen,
      };
      const resultsId = `apinet${new Date().getTime()}_${Math.random().toString(36).substring(7)}`;
      const request = axios
        .post(`${env.BACKEND}/api/domain?resultsId=${resultsId}`, postBody)
        .then((res) => {
          const rid = resultsId;
          rids.push(rid);
          return rid;
        })
        .catch((err) => {
          console.error(`Request for resultsId ${resultsId} failed`, err.response);
          return null;
        });
      requests.push(request);
    }
    if (this.state.selectedMethods.includes('gosim')) {
      hspecies = hosts
        .find((item) => item.name === this.state.species)
        .sname.replaceAll(" ", "_")
        .replaceAll(".", "")
        .replaceAll("(", "_")
        .replaceAll(")", "_");
      let postBody = {
        category: 'gosim',
        hspecies: hspecies,
        pspecies: this.state.pathogen,
        hostProteins: this.state.hgenes,
        pathogenProteins: this.state.pgenes,
        measure: this.state.gomeasure,
        orgDb: this.state.goorgdb,
        minSimilarity: this.state.gominsimilarity,
      };
      const request = axios
        .post(`${env.BACKEND}/api/goppi/`, postBody)
        .then((res) => {
          const rid = res.data;
          rids.push(rid);
          return rid;
        })
        .catch((err) => {
          console.error(`Request for GOsim failed`, err.response);
          return null;
        });
      requests.push(request);
    }
    if (this.state.selectedMethods.includes('phylo')) {
      hspecies = hosts
        .find((item) => item.name === this.state.species)
        .sname.replaceAll(" ", "_")
        .replaceAll(".", "")
        .replaceAll("(", "_")
        .replaceAll(")", "_");
      let postBody = {
        category: 'phylo',
        hspecies: hspecies,
        pspecies: this.state.pathogen,
        host_genes: this.state.hgenes,
        pathogen_genes: this.state.pgenes,
        method: this.state.genomePool,
        threshold: this.state.phylothreshold,
        hi: this.state.phyloIdentity,
        hc: this.state.phyloCoverage,
        he: this.state.phyloEvalue,
        pi: this.state.phyloPidentity,
        pc: this.state.phyloPcoverage,
        pe: this.state.phyloPevalue,
      };

      const request = axios
        .post(`${env.BACKEND}/api/phyloppi/`, postBody)
        .then((res) => {
          const rid = res.data;
          rids.push(rid);
          return rid;
        })
        .catch((err) => {
          console.error(`Request for phylo-profiling failed`, err.response);
          return null;
        });
      requests.push(request);
    }
    if (this.state.selectedMethods.includes('interolog')) {
      let postBody = {
        category: 'interolog',
        hspecies: hspecies,
        pspecies: pspecies,
        idType: this.state.idType,
        genes: this.state.genes,
        searchType: this.state.searchType,
        hi: this.state.interologIdentity,
        hc: this.state.interologCoverage,
        he: this.state.interologEvalue,
        pi: this.state.interologPidentity,
        pc: this.state.interologPcoverage,
        pe: this.state.interologPevalue,
        intdbs: intdbd,
        keyword: this.state.keyword,
        annotType: this.state.annotType,
        host: hspecies,
        pathogen: this.state.pathogen,
      };
      this.openModel();
      const request = axios
        .post(`${env.BACKEND}/api/interolog`, postBody)
        .then((res) => {
          const rid = res.data;
          rids.push(rid);
          return rid;
        })
        .catch((err) => {
          console.error(`Request for interolog failed`, err.response);
          return null;
        });
      requests.push(request);
    }

    Promise.all(requests)
      .then((results) => {
        if (rids.length === 1) {
          this.setState({ resultid: rids[0] });
          window.location.replace(`${env.BASE_URL}/results/?id=${rids[0]}`);
        } else {
          const resultsId = `apinet${new Date().getTime()}_${Math.random().toString(36).substring(7)}`;
          const postBody = {
            rids: rids,
            combinationType: this.state.type,
            hspecies: hspecies,
            pspecies: this.state.pathogen,
          }
          console.log(this.state)
          let url = `${env.BACKEND}/api/${this.state.type}?resultsId=${resultsId}`;
          axios
            .post(url, postBody)
            .then((res) => {
              const rid = resultsId;
              rids.push(rid);
              // console.log(rid);
              this.setState({ resultid: rid });

              this.closeModel();
              window.location.replace(`${env.BASE_URL}/results/?id=${rid}`);
            })
            .catch((err) => {
              console.error(err.response)

              this.closeModel();
            });
        }
      })
      .catch((err) => {
        console.error("Error handling requests:", err);
      });
  }

  componentDidMount() {
    this.fetchSampleProteins(); // Fetch samples when component loads
  }

  render() {
    const { selectedMethods } = this.state;
    localStorage.setItem(
      "param",
      JSON.stringify({
        ihe: this.state.interologEvalue,
        ihi: this.state.interologIdentity,
        ihc: this.state.interologCoverage,
        ipe: this.state.interologPevalue,
        ipi: this.state.interologPidentity,
        ipc: this.state.interologPcoverage,
        phe: this.state.phyloEvalue,
        phi: this.state.phyloIdentity,
        phc: this.state.phyloCoverage,
        ppe: this.state.phyloPevalue,
        ppi: this.state.phyloPidentity,
        ppc: this.state.phyloPcoverage,
        resultid: this.state.resultid,
        categories: this.state.selectedMethods,
        species: this.state.species,
        pathogen: this.state.pathogen,
        domdbs: this.state.dcheckedList,
        idType: this.state.idType,
        genes: this.state.genes,
        hgenes: this.state.hgenes,
        pgenes: this.state.pgenes,
        gomeasure: this.state.gomeasure,
        goorgdb: this.state.goorgdb,
        gominsimilarity: this.state.gominsimilarity,
        keyword: this.state.keyword,
        searchType: this.state.searchType,
        annotType: this.state.annotType,
        hspecies: this.state.hspecies,
        pspecies: this.state.pspecies
      })
    );
    
    let genePlaceholder = "Enter protein IDs (comma, newline, or tab separated)..."; // Default
    const idType = this.state.idType;
    const sampleHostProteins = this.state.sampleHostProteins;
    const samplePathogenProteins = this.state.samplePathogenProteins;
    const sampleProteinsLoading = this.state.sampleProteinsLoading;
    const sampleProteinsError = this.state.sampleProteinsError;

    if (sampleProteinsLoading) {
        genePlaceholder = "Loading sample IDs...";
    } else if (sampleProteinsError) {
        genePlaceholder = `Error loading samples. ${sampleProteinsError}`;
    } else {
        let sampleList = [];
        if (idType === 'host' && sampleHostProteins.length > 0) {
            sampleList = sampleHostProteins;
        } else if (idType === 'pathogen' && samplePathogenProteins.length > 0) {
            sampleList = samplePathogenProteins;
        }

        if (sampleList.length > 0) {
            let idSource = 'NCBI protein';
            if (this.state.idType === 'host' && this.state.hspecies === 'Bos_grunniens') {
                idSource = 'ENSEMBL protein';
            } 
            if (this.state.idType === 'pathogen' && this.state.pspecies === 'Candida_auris') {
                idSource = 'UniProt';
            } else if (this.state.idType === 'pathogen' && ['Claviceps_purpurea', 'Trichophyton_mentagrophytes'].includes(this.state.pspecies)) {
                idSource = 'NCBI gene';
            }
            genePlaceholder = `Example ${idType} ${idSource} IDs: ${sampleList.slice(0, 5).join(', ')}`; // Show up to 5 examples
        } else {
            genePlaceholder = `No sample ${idType} IDs found for this pair. Enter IDs manually.`;
        }
    }
    
    return (
      <div className="container">
        {localStorage.setItem("resultid", JSON.stringify(this.state.resultid))}
        <Divider />
        <div className="row justify-content-center">
          <div className="col-md-4">
            <h5>Selected Host: {mhost}</h5>
          </div>

          <div className="col-md-4">
            <h5>
              Selected Pathogen: <i>{pathogen[mpath]}</i>
            </h5>
          </div>
        </div>
        <Modal show={this.state.ppiOpen} onHide={this.ppiModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About PPI Databases</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              Since HPIDB is the only database that contains exclusively host-pathogen
              interactions, including any type of pathogen, it has been chosen as the
              default database. VirHostNet also has host-pathogen interactions only, but
              just viral proteins. The other databases include any type of interactions.
            </p>
            <hr></hr>
            <p className="info">
              Summary of the databases version running on this service:
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="http://hpidb.igbb.msstate.edu/"
              >
                HPIDB
              </a>{" "}
              has 17,042 sequences with 63,689 interactions.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://mint.bio.uniroma2.it/"
              >
                MINT
              </a>{" "}
              has 34,196 sequences with 102,749 interactions.
            </p>
            {/* <p className="info">
              <a target="_blank" rel="noreferrer" href="https://string-db.org/">
                STRING
              </a>{" "}
              have 97,483 sequences with 4,944,287 interactions.
            </p> */}
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://thebiogrid.org/"
              >
                BioGRID
              </a>{" "}
              has 22,166 sequences with 83,526 interactions.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.ebi.ac.uk/intact/"
              >
                IntAct
              </a>{" "}
              has 39,940 sequences with 106,876 interactions.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://virhostnet.prabi.fr/"
              >
                VirHostNet
              </a>{" "}
              have 9,758 sequences with 42,070 interactions.
            </p>
            <hr></hr>
            <p className="info" style={{ color: "tomato" }}>
              Note: There can be overlapping data between databases.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.ppiModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.domainOpen} onHide={this.domainModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About Domain-Domain Interaction Databases</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              3DID is the database whose domain-domain interactions have a high confidence,
              due to them being extracted from high-resolution 3D protein structures available
              in the Protein Data Bank (PDB). Hence, 3DID is the default database. On the other
              hand, both IDDI and DOMINE include predicted domain-domain interactions, which
              lowers the confidence.
            </p>
            <hr></hr>
            <p className="info">
              Summary of the databases version running on this service:
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://3did.irbbarcelona.org/"
              >
                3DID
              </a>{" "}
              has 8,580 domains and 15,983 interactions.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://pmc.ncbi.nlm.nih.gov/articles/PMC3380739/"
              >
                IDDI (Webpage not available)
              </a>{" "}
              has 6,717 domains and 199,759 interactions.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://3did.irbbarcelona.org/"
              >
                DOMINE
              </a>{" "}
              has 5,410 domains and 26,219 interactions.
            </p>
            <hr></hr>
            <p className="info" style={{ color: "tomato" }}>
              Note: There can be overlapping data between databases.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.domainModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.goOpen} onHide={this.goModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About GOSemSim</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              The GO semantic similarity-based prediction requires choosing a
              method to calculate the semantic similarity between GO terms.
              Wang is the default method due to its simplicity. The other
              methods require picking a Bioconductor model annotation map.
            </p>
            <p className="info">
              Due to the high number of GO terms associated with every protein,
              the computation can take a long time in large datasets. For this reason,
              it is required to input a list of proteins to be evaluated.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.goModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.phyloOpen} onHide={this.phyloModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About Phylo-profiling</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              Phylo-profiling-based interactions make use of the model proteomes
              of different pools. It executes a BLAST analysis of each protein
              against all proteomes of the selected pool, and based on the
              existence or absence of each protein in each proteome (coded as 1 or 0),
              it compares the similarity of the host and pathogen proteins' strings
              made up of this 1s and 0s.
            </p>
            <p className="info">
              Due to the high number of BLAST analyses, the computation can take a
              long time in large datasets. For this reason, it is required to input a
              list of proteins to be evaluated.
            </p>
            <p className="info">
              Summary of the pools used:
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://bioconductor.org/packages/release/data/annotation/"
              >
                Bioconductor's Org.Db
              </a>{" "}
              has 20 proteomes.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.uniprot.org/"
              >
                UniProt
              </a>{" "}
              has 490 proteomes.
            </p>
            <p className="info">
              <a
                target="_blank"
                rel="noreferrer"
                href="."
              >
                SC
              </a>{" "}
              has 82 proteomes.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.phyloModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.consensusOpen} onHide={this.consensusModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About Consensus</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              The consensus option lets you run multiple methods for a single host-pathogen pair. After all methods are done calculating,
              APInet will find the pairs that exist in all the result sets. Thus, if an interaction between proteins A and B does not appear
              in one of the methods, it will not be retrieved.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.consensusModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.concatenationOpen} onHide={this.concatenationModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About Concatenation</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              The concatenation option lets you run multiple methods for a single host-pathogen pair. After all methods are done calculating,
              APInet will concatenate all the result sets and will display every pair found with their respective method it was predicted with.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.concatenationModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.fileOpen} onHide={this.fileModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About Protein IDs List Upload</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              You can upload a list of protein IDs to be evaluated. The list should be in a text file with comma-separated values.
            </p>
            <hr></hr>
            <p className="info">
              Example:
            </p>
            <p className="info">
              protein1,protein2,protein3
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.fileModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Divider />

        <div className="row flex-lg-row justify-content-center">
          <div className="col-md-6">
            <Radio.Group value={this.state.type} onChange={this.radioHandler}>
              <h3>Select Type</h3>
              <Radio value="single" >
                Single
              </Radio>
              <Radio value="consensus">
                Consensus <InfoCircleOutlined onClick={this.consensusModalOpen} />
              </Radio>
              <Radio value="concatenation" >
                Concatenation <InfoCircleOutlined onClick={this.concatenationModalOpen} />
              </Radio>
            </Radio.Group>
          </div>
          <div className="col-md-6">
            <Checkbox.Group value={this.state.selectedMethods} onChange={this.checkboxHandler}>
              <h3>Select Interaction Method</h3>
              <Checkbox value="interolog" >
                Interolog
              </Checkbox>
              <Checkbox value="domain">
                Domain
              </Checkbox>
              <Checkbox value="gosim" >
                GOSemSim
              </Checkbox>
              <Checkbox value="phylo" >
                Phylo-profiling
              </Checkbox>
            </Checkbox.Group>
          </div>
          <Divider />
        </div>
        {this.state.searchType === "accession" &&
          this.state.status !== "gosim" &&
          this.state.status !== "phylo" && (
            <div className="row flex-lg-row align-items-center">
              <div className="col-md-3">
                <h5>Select IDs Type</h5>
                <Radio.Group name="radiogroup" defaultValue={"host"}>
                  <Radio value="host" onChange={this.accessionHandler}>
                    Host
                  </Radio>
                  <Radio value="pathogen" onChange={this.accessionHandler}>
                    Pathogen
                  </Radio>
                </Radio.Group>
              </div>

              <div className="col-md-5">
                <h5>Enter protein or protein IDs here.</h5>
                <Form.Control
                  className="kbl-form mb-4"
                  as="textarea"
                  rows={4}
                  placeholder={genePlaceholder}
                  onChange={this.geneHandler}
                  value={this.state.genes}
                  onMouseEnter={() => this.setGeneHint(true)}
                  onMouseLeave={() => this.setGeneHint(false)}
                  spellCheck={false}
                />
                <Button
                  className="kbl-btn-1 mx-3"
                  onClick={(e) => {
                    this.setState({ genes: this.state.idType === 'host' ? sampleHostProteins.join(',') : samplePathogenProteins.join(',') });
                  }}
                >
                  Sample Data
                </Button>
                <Button
                  className="kbl-btn-3"
                  onClick={(e) => {
                    this.setState({ genes: "" });
                  }}
                >
                  Clear Data
                </Button>
              </div>
              <div className="col-md-1">
                <b>OR</b>
              </div>
              <div className="col-md-3 mb-5">
                <h5 className="mt-5 pl-2"> Upload Protein IDs List</h5>

                <FileInput handler={this.fileSelected} />
              </div>
              <Divider />
            </div>
          )}
        {selectedMethods.includes("interolog") && (
          <div>
            <h4>Interolog Options</h4>
            <div className="row flex-lg-row justify-content-center g-2 my-3">
              <h5>
                Select Interaction Databases{" "}
                <InfoCircleOutlined onClick={this.ppiModalOpen} />
              </h5>
              <div className="col-md-6">
                <CheckboxGroup
                  options={interologOptions}
                  value={this.state.checkedList}
                  onChange={this.onChange}
                />
              </div>
              <div className="col-md-2">
                <Checkbox
                  onChange={this.onCheckAllChange}
                  checked={this.state.checkAll}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
            <div className="row flex-lg-row justify-content-center g-2 my-3">
              <div className="col-md-6">
                <div className="row flex-lg-row justify-content-center">
                  <h5>Host Alignment Filtering Options</h5>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Identity %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.interologIdentity}
                        onChange={this.interologIdentityHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Coverage %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.interologCoverage}
                        onChange={this.interologCoverageHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Evalue</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.interologEvalue}
                        onChange={this.interologEvalueHandler}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row flex-lg-row justify-content-center">
                  <h5>Pathogen Alignment Filtering Options</h5>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Identity %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.interologPidentity}
                        onChange={this.interologPidentityHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Coverage %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.interologPcoverage}
                        onChange={this.interologPcoverageHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Evalue</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.interologPevalue}
                        onChange={this.interologPevalueHandler}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
              <Divider />
            </div>
          </div>
        )}
        {selectedMethods.includes("domain") && (
          <div>
            <h4>Domain Options</h4>
            <div className="row flex-lg-row justify-content-center g-2 my-3">
              <h5>
                Select Domain Databases{" "}
                <InfoCircleOutlined onClick={this.domainModalOpen} />
              </h5>

              <div className="col-md-6">
                <CheckboxGroup
                  options={domainOptions}
                  value={this.state.dcheckedList}
                  onChange={this.onChange2}
                />
              </div>
              <div className="col-md-2">
                <Checkbox
                  onChange={this.onCheckAllChange2}
                  checked={this.state.dcheckAll}
                >
                  Check all
                </Checkbox>
              </div>

              <Divider />
            </div>
          </div>
        )}
        {selectedMethods.includes("gosim") && (
          <div>
            <h4>GOSemSim Options</h4>
            <div className="row flex-lg-row justify-content-center g-2 my-3">
              <div className="col-md-4">
                <Radio.Group name="radiogroup" defaultValue={"Wang"}>
                  <h5>
                    Select GO Semantic Similarity Method{" "}
                    <InfoCircleOutlined onClick={this.goModalOpen} />
                  </h5>
                  <Radio value="Wang" onClick={this.goMeasureRadioHandler}>
                    Wang
                  </Radio>
                  <Radio value="Resnik" onClick={this.goMeasureRadioHandler}>
                    Resnik
                  </Radio>
                  <Radio value="Rel" onClick={this.goMeasureRadioHandler}>
                    Rel
                  </Radio>
                  <Radio value="Jiang" onClick={this.goMeasureRadioHandler}>
                    Jiang
                  </Radio>
                  <Radio value="Lin" onClick={this.goMeasureRadioHandler}>
                    Lin
                  </Radio>
                  <Radio value="TCSS" onClick={this.goMeasureRadioHandler}>
                    TCSS
                  </Radio>
                </Radio.Group>
              </div>

              <div className="col-md-3">
                <h5>Select Min. Similarity</h5>
                <Slider
                  defaultValue={50}
                  marks={{ 0: "0", 100: "100" }}
                  disabled={false}
                  min={0}
                  max={100}
                  onChange={this.getGoMinSimilarity}
                />
              </div>

              {this.state.gomeasure !== 'Wang' && (
                <div id='orgDb' className="col-md-3">
                  <h5>Select Org.Db Species</h5>
                  <Select className="w-75" defaultValue='org.Hs.eg.db' onChange={this.goOrgDbSelectHandler}>
                    {Object.entries(orgDb).map(([name, db]) => (
                      <Select.Option key={db} value={db}>{name}</Select.Option>
                    ))}
                  </Select>
                </div>
              )}
            </div>
            <Divider />
          </div>
        )}
        {selectedMethods.includes("phylo") && (
          <div>
            <h4>Phylo-Profiling Options</h4>
            <div className="row flex-lg-row justify-content-center g-2 my-3">
              <div className="col-md-6">
                <Radio.Group name="radiogroup" defaultValue={"UP82"}>
                  <h5>
                    Select Genome Pool{" "}
                    <InfoCircleOutlined onClick={this.phyloModalOpen} />
                  </h5>
                  <Radio value="UP82" onClick={this.pgHandler}>
                    UniProt (82)
                  </Radio>
                  <Radio value="BC18" onClick={this.pgHandler}>
                    Bioconductor (20)
                  </Radio>
                  <Radio value="protphylo490" onClick={this.pgHandler}>
                    ProtPhylo (490)
                  </Radio>
                </Radio.Group>
              </div>
              <div className="col-md-4">
                <h5>Threshold (Min Similarity)</h5>
                <div className="form-inline">
                  {/* <label className="label-text">Identity %</label> */}
                  <input
                    className="form-control"
                    type="text"
                    value={this.state.phylothreshold}
                    onChange={this.phyloThresholdHandler}
                  ></input>
                </div>
              </div>
            </div>
            <div className="row flex-lg-row justify-content-center">
              <div className="col-md-6">
                <div className="row flex-lg-row justify-content-center">
                  <h5>Host Alignment Filtering Options</h5>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Identity %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.phyloIdentity}
                        onChange={this.phyloIdentityHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Coverage %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.phyloCoverage}
                        onChange={this.phyloCoverageHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Evalue</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.phyloEvalue}
                        onChange={this.phyloEvalueHandler}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row flex-lg-row justify-content-center">
                  <h5>Pathogen Alignment Filtering Options</h5>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Identity %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.phyloPidentity}
                        onChange={this.phyloPidentityHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Coverage %</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.phyloPcoverage}
                        onChange={this.phyloPcoverageHandler}
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-inline">
                      <label className="label-text">Evalue</label>
                      <input
                        className="form-control"
                        type="text"
                        value={this.state.phyloPevalue}
                        onChange={this.phyloPevalueHandler}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Divider />
          </div>
        )}
        {(selectedMethods.includes("phylo") || selectedMethods.includes("gosim")) && (
          <>
            <div className="row flex-lg-row justify-content-center g-2 my-3">
              {selectedMethods.includes("gosim") && selectedMethods.includes("phylo") && (
                <h4>GOSemSim and Phylo-Profiling Filter (<span style={{ textDecoration: 'underline' }}>Mandatory</span>)</h4>
              )}
              {selectedMethods.includes("gosim") && !selectedMethods.includes("phylo") && (
                <h4>GOSemSim Filter (<span style={{ textDecoration: 'underline' }}>Mandatory</span>)</h4>
              )}
              {selectedMethods.includes("phylo") && !selectedMethods.includes("gosim") && (
                <h4>Phylo-Profiling Filter (<span style={{ textDecoration: 'underline' }}>Mandatory</span>)</h4>
              )}
              <div className="col-md-5">
                <h5>Enter Host Protein IDs</h5>
                <Form.Control
                  className="kbl-form mb-4"
                  as="textarea"
                  rows={4}
                  placeholder={ sampleHostProteins.join(',') }
                  onChange={this.handleHostGeneChange}
                  value={this.state.hgenes}
                  onMouseEnter={() => this.setGeneHint(true)}
                  onMouseLeave={() => this.setGeneHint(false)}
                  spellCheck={false}
                />
              </div>
              <div className="col-md-5">
                <h5>Enter Pathogen Protein IDs</h5>
                <Form.Control
                  className="kbl-form mb-4"
                  as="textarea"
                  rows={4}
                  placeholder={ samplePathogenProteins.join(',') }
                  onChange={this.handlePathogenGeneChange}
                  value={this.state.pgenes}
                  onMouseEnter={() => this.setGeneHint(true)}
                  onMouseLeave={() => this.setGeneHint(false)}
                  spellCheck={false}
                />
              </div>
            </div>
            <div className="row flex-lg-row justify-content-center my-3">
              <div className="col-md-4">
                <Button
                  className="kbl-btn-1 mx-3"
                  onClick={(e) => {
                    this.setState({ pgenes: samplePathogenProteins.join(',')});
                    this.setState({ hgenes: sampleHostProteins.join(',') });
                  }}
                >
                  Sample Data
                </Button>
                <Button
                  className="kbl-btn-2"
                  onClick={(e) => {
                    this.setState({ pgenes: "" });
                    this.setState({ hgenes: "" });
                  }}
                >
                  Clear Data
                </Button>
              </div>
            </div>
            <Divider />
          </>
        )}
        {
          (
            this.state.type === 'concatenation' ||
            !(selectedMethods.includes("phylo") || selectedMethods.includes("gosim"))
          )
          &&
          (selectedMethods.includes("interolog") || selectedMethods.includes("domain")) && (
            <>
              <div className="row flex-lg-row justify-content-center g-2">
                {selectedMethods.includes("interolog") && selectedMethods.includes("domain") && (
                  <h4>Interolog and Domain Filter (<span style={{ textDecoration: 'underline' }}>Optional</span>)</h4>
                )}
                {selectedMethods.includes("interolog") && !selectedMethods.includes("domain") && (
                  <h4>Interolog Filter (<span style={{ textDecoration: 'underline' }}>Optional</span>)</h4>
                )}
                {selectedMethods.includes("domain") && !selectedMethods.includes("interolog") && (
                  <h4>Domain Filter (<span style={{ textDecoration: 'underline' }}>Optional</span>)</h4>
                )}
                <div className="col-md-3">
                  <h5>Select Species Type</h5>
                  <Radio.Group name="radiogroup" defaultValue={"host"}>
                    <Radio value="host" onChange={this.accessionHandler}>
                      Host
                    </Radio>
                    <Radio value="pathogen" onChange={this.accessionHandler}>
                      Pathogen
                    </Radio>
                  </Radio.Group>
                </div>
                <div className="col-md-3">
                  <h5>Select Search Type</h5>
                  <Radio.Group name="radiogroup" defaultValue={"protein"}>
                    <Radio value="protein" onChange={this.searchHandler}>
                      Protein ID
                    </Radio>
                    <Radio value="keyword" onChange={this.searchHandler}>
                      Keyword
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
              <br></br>
              {this.state.searchType === 'keyword' && (
                <>
                  <div className="row flex-lg-row align-items-center g-2">
                    <h5>Select Annotation</h5>
                    <Radio.Group name="radiogroup" defaultValue={"go"}>
                      <Radio value="go" onChange={this.annotationHandler}>
                        Gene Ontology
                      </Radio>
                      <Radio value="pathway" onChange={this.annotationHandler}>
                        KEGG Pathways
                      </Radio>
                      <Radio value="local" onChange={this.annotationHandler}>
                        Subcellular Localization
                      </Radio>
                      {this.state.idType === 'host' && (
                        <>
                          <Radio value="tf" onChange={this.annotationHandler}>
                            Transcription Factors
                          </Radio>
                        </>
                      )}
                      {this.state.idType === 'pathogen' && (
                        <>
                          <Radio value="virulence" onChange={this.annotationHandler}>
                            Virulence Proteins
                          </Radio>
                        </>
                      )}
                      <Radio value="interpro" onChange={this.annotationHandler}>
                        Functional Domains
                      </Radio>
                    </Radio.Group>
                    <Divider />
                  </div>
                  <div className="row flex-lg-row justify-content-center g-2">
                    <div className="col-md-2"></div>
                    <div className="col-md-6">
                      <h6>Enter a Keyword (e.g: Ubiquitin)</h6>
                      <Input placeholder="keyword" value={this.state.keyword} onChange={this.keywordHandler} />
                    </div>
                    <div className="col-md-2 mt-4">
                      <Button className="kbl-btn-3" onClick={e => {
                        this.setState({ keyword: "" })
                      }}>Clear Data</Button>
                    </div>
                    <Divider />
                  </div>
                </>
              )}
              {this.state.searchType === 'protein' && (
                <>
                  <div className="row flex-lg-row justify-content-center">
                    <div className="col-md-5">
                      <h5>Enter protein or protein IDs here.</h5>
                      <Form.Control className="kbl-form mb-4" as="textarea" rows={4} placeholder={genePlaceholder} onChange={this.geneHandler}
                        value={this.state.genes} onMouseEnter={() => this.setGeneHint(true)} onMouseLeave={() => this.setGeneHint(false)} spellCheck={false} />
                      <Button className="kbl-btn-1 mx-3" onClick={e => {
                        this.setState({ genes: this.state.idType === 'host' ? sampleHostProteins.join(',') : samplePathogenProteins.join(',') });
                      }}>Sample Data</Button>
                      <Button className="kbl-btn-3" onClick={e => {
                        this.setState({ genes: "" })
                      }}>Clear Data</Button>
                    </div>
                    <div className="col-md-1 mt-5"><b>OR</b></div>
                    <div className="col-md-3 mb-5">
                      <h5>
                        Upload Protein IDs List{" "}
                        <InfoCircleOutlined onClick={this.fileModalOpen} />
                      </h5>
                      <FileInput handler={this.fileSelected} />
                    </div>
                    <Divider />
                  </div>
                </>
              )}
            </>
          )
        }
        {selectedMethods.length === 0 && (
          <h4>Please, select at least one option.</h4>
        )}

        <div className="row flex-lg-row justify-content-center g-2 my-3">
          {this.state.isOpen && (
            <div className="col-md-8">
              <h5 className="mb-3">Please wait. Your query is being processed.</h5>
              <img src={test} className="loading" height="50px" alt=""></img>
            </div>
          )}
          {this.state.isOpen === false && selectedMethods.length > 0 && (
            <div className="col-md-2">
              <Button
                type="primary"
                shape="square"
                size="large"
                onClick={this.getInteractions}
              >
                Show Interactions{" "}
              </Button>
            </div>
          )}
        </div>
        <Divider />
      </div>
    );
  }
}
